import objectAssign from 'object-assign';
import initialState from './initialState';

import intersection from 'lodash/intersection';
import isString from 'lodash/isString';

import {
  locale,
  configuratorType
} from '../i18n.js';
const productConditions = function () {
  try {
    return require(`../data/${configuratorType}_conditions${locale ? '_' + locale : ''}.json`);
  } catch (error) {
    // return require(`../data/shower_conditions_en_gb.json`);
    return require(`../data/${configuratorType}_conditions_en_gb.json`);
  }

}();

/**
 *  checks if scenario/condition props (requires; preset etc.) are being fulfilled by current selected items
 */
const matchConditions = (conditions, selectedItems) => {
  if (isString(conditions)) {
    conditions = [conditions];
  }
  return conditions.reduce((prev, block) => {
    // break out of iteration if prev is true
    if (prev) {
      return true;
    }
    // iterate through sections seperated by semicolon
    const requireMatches = block.split(' && ').reduce((prev, current) => {
      // break out of iteration when previous section returned false
      if (!prev) {
        return false;
      }
      // get negative require matches to current section
      const negativeRequires = current.split(',').filter(item => item.indexOf('!') > -1).map(item => item.replace('!', ''));
      const negativeRequiresMatches = negativeRequires.length > 0 ? intersection(negativeRequires, selectedItems).length === 0 : true;
      // get positive require matches to current section
      const positiveRequires = current.split(',').filter(item => item.indexOf('!') === -1);
      const positiveRequireMatches = positiveRequires.length > 0 ? intersection(positiveRequires, selectedItems).length > 0 : true;

      // return combined matches
      let anyRequiresMatches = positiveRequireMatches && negativeRequiresMatches;
      return anyRequiresMatches;
    }, true);
    return requireMatches;
  }, false);
};

export default function reducer(state = initialState.configurator, action) {
  let newState;
  newState = objectAssign({}, state);

  switch (action.type) {
    case 'SAVE_SELECTED':
      {
        // reset results
        let results = [];
        //  newState.selected = [ ...new Set(objectAssign(newState.selected))];
        //check if new element to add is in array already
        const id = action.payload.id;
        const slug = id ? action.payload.id.substr(0, action.payload.id.indexOf('_')) : false;
        //44rg0cc newState.questions =[ ...new Set(objectAssign(newState.questions))];
        let questions = [...newState.questions];
        const currentQuestionIndex = !slug ? 0 : questions.findIndex(question => question.slug === slug);
        const currentQuestion = questions[currentQuestionIndex];
        console.log('currentQuestion', currentQuestion);
        questions[currentQuestionIndex] = { ...currentQuestion,
          value: id
        };

        for (let i = currentQuestionIndex + 1; i < questions.length; i++) {
          questions[i] = { ...questions[i],
            value: false,
            visible: false
          };
        }
        const selectedItems = [locale, ...questions
          // values "question-slug_opt1" etc.
          .filter(question => question.value && question.visible)
          .map(question => question.value),
          // add slugs "question-slug"
          ...questions
          .filter(question => question.value && question.visible)
          .map(question => question.slug)
        ];

        // match conditions of items and options
        questions = questions
        .map(question => {
          const visible = question.conditions ? matchConditions(question.conditions, selectedItems) : true;
          const options = question.options.map(option => {
            const visible = option.conditions ? matchConditions(option.conditions, selectedItems) : true;
            // override default image
            if (visible && option.images) {
              const newImage = option.images.find(img => matchConditions(img.conditions, selectedItems));
              option = { ...option,
                image: newImage ? newImage.image : option.imageDefault
              };
            }
            return { ...option,
              visible
            };
          });

          const showInvisibleQuestions = window.localStorage.getItem('debug');
          const hasMoreThanOneOption = showInvisibleQuestions ? options.filter(option => option.visible).length > 0 : options.filter(option => option.visible).length > 1;
          const hasOneOption = options.filter(option => option.visible).length === 1;
          if (visible && hasOneOption) {
            // if question has only one question, automatically set its value
            question.value = options.filter(option => option.visible)[0].id;
            selectedItems.push(question.value);
            selectedItems.push(question.slug);
          }

          return { ...question,
            visible: visible ? hasMoreThanOneOption : visible,
            options,
          };
        });

        console.log('selectedItems', selectedItems);
        // done?
        newState.showResults = questions.filter(question => question.visible && !question.value).length === 0;
        if (newState.showResults) {
          results = productConditions.reduce((prev, current) => {
            if (matchConditions(current.conditions, selectedItems)) {
              prev = [...prev, current.groups];
            }
            return prev;
          }, []);
        }

        console.log('results', results);

        return { ...newState,
          questions,
          selectedItems,
          results
        };
      }
    case 'INIT_STATE':
      {
        // eslint-disable-next-line no-unused-vars
        let questions = action.payload.questions;
        questions = questions.map((question, i) => {
          if (i === 0) {
            question.visible = true;
          }
          question.options = question.options.map((option, i) => {
            option.id = option.id ? option.id : `${question.slug}_opt${i}`;
            option.selected = false;
            if (option.images && option.image) {
              option.imageDefault = option.image;
            }
            option.visible = true;
            return option;
          });
        });
        return objectAssign(newState, action.payload);
      }
    case 'GET_SELECTED':
      {
        return newState;
      }
    case 'RESET_CONFIGURATOR':
      {
        return { ...newState,
          showResults: false,
          questions: newState.questions.map((question, i) => ({ ...question,
            value: false,
            visible: i === 0
          }))
        };
      }
    case 'PUSH_RESULT':
      {
        newState.results = [...new Set(objectAssign(newState.results.concat(action.payload[0])))];
        newState.bundles = [...new Set(objectAssign(newState.bundles.concat(action.payload[1])))];
        return newState;
      }
    case 'SET_SCROLL_INDICATOR':
      {
        newState.showScrollIndicator = action.payload;
        return newState;
      }
    case 'SET_LAST_QUESTION_ID':
      {
        newState.lastQuestionId = action.payload;
        return newState;
      }
  }
  return newState;
}



// WEBPACK FOOTER //
// ./src/reducers/selectionReducer.js